import { Component, ContentChild, TemplateRef, Input, OnChanges, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { Auftrag } from '../../Api/DcoApi/Auftraege';
@Component({
  selector: 'Auftrag-Card',
  templateUrl: './AuftragCard.html',
  styleUrl: './AuftragCard.css'
})
export class AuftragCard implements OnChanges {
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['Auftrag']) {
      console.log(this.bodyTemplate);
      this.cdr.detectChanges();
    }
  }
  // Sucht im Content nach #cardBody
  @ContentChild('cardBody', { static: false }) bodyTemplate?: TemplateRef<Auftrag>;
  @Input() HeaderText: string = "";
  @Input() IsVisible: Boolean = true;
  @Input() Auftrag: Auftrag | null = null;

  constructor(private cdr: ChangeDetectorRef) { }
 
}
